import React, { useState } from "react";
import { toast } from "react-toastify";
import MemberMembershipService from "../../../../../../services/member_membership_service";
import { NeoButton } from "../../../../../../components/Common";

const ActionEndSuspension = ({ membership, idTenant, user, onRefresh }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        try {
            setLoading(true);
            await MemberMembershipService.endSuspension(membership.id, idTenant, user, membership);
            toast.success("Plano destrancado e dias estornados com sucesso!");
            if (onRefresh) onRefresh();
        } catch (error) {
            console.error("Erro ao destrancar", error);
            toast.error(error.message || "Erro ao destrancar plano.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-4 border mt-3 bg-white shadow-sm" style={{ borderRadius: '12px', borderColor: 'rgba(0, 0, 0, 0.06)', fontFamily: 'Outfit, sans-serif' }}>
            <div className="d-flex align-items-center mb-3">
                <i className="mdi mdi-play-circle-outline fs-4 me-2 text-muted" style={{ color: 'var(--color-brand-secondary) !important' }}></i>
                <h6 className="fw-bold mb-0 text-uppercase" style={{ letterSpacing: "0.5px", color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>
                    Finalizar Trancamento
                </h6>
            </div>
            <p className="text-muted font-size-13 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Isso irá religar o plano e ativar o aluno imediatamente. Os dias agendados que não foram utilizados serão <strong>estornados e devolvidos</strong> para o saldo de suspensões disponíveis, e a data de vencimento será recalculada.
            </p>

            <div className="d-flex justify-content-end">
                <NeoButton 
                    variant="primary" 
                    onClick={handleConfirm} 
                    loading={loading} 
                    size="sm"
                    className="px-4"
                >
                    Confirmar Reativação
                </NeoButton>
            </div>
        </div>
    );
};

export default ActionEndSuspension;
